module.exports = "<ztr-progress-bar max=\"vm.max\" current=\"vm.progress\" message=\"{{vm.progress | millisecondsFormat}}\">\r\n  </progress-bar>";